import React, { useCallback, useState } from 'react'
import Resx from '@/components/Resx'
import { InputEditorFunc, areEditorPropsEqual } from '@/components/report-tables/editors/fInputEditor'
import { Select } from 'antd'

const BoolEditorFunc = React.memo(function BoolEditorFunc ({ onChange, ...props }) {
  const [open, setOpen] = useState(true)
  const [ignoreFirst, setIgnore] = useState(true)

  const onInputChange = useCallback((event) => {
    onChange(event)
  }, [onChange])

  const getValue = useCallback((value, _) => { return { value } }, [])

  const onOpen = useCallback((o) => {
    if (!ignoreFirst) setOpen(o)
    else setIgnore(false)
  }, [ignoreFirst])

  const render = useCallback((value) => {
    return (
      <Resx render={({ localize }) =>
        // Using ant select due to html select not being able to render opened
        <Select
          autoFocus
          onChange={onInputChange}
          value={value}
          style={{ width: '100%', bottom: '3px' }}
          open={open}
          onDropdownVisibleChange={onOpen}
        >
          <Select.Option value='' >&nbsp;</Select.Option>
          <Select.Option value='True'>{localize('Common.Yes')}</Select.Option>
          <Select.Option value='False'>{localize('Common.No')}</Select.Option>
        </Select>
      } />)
  }, [onInputChange, onOpen, open])

  return <InputEditorFunc {...props}
    onInputChange={onInputChange}
    getValue={getValue}
    render={render} />
}, areEditorPropsEqual)

export { BoolEditorFunc }



// WEBPACK FOOTER //
// ./src/components/report-tables/editors/fBoolEditor.js